import {request, serviceUrl} from "@/utils/request";

//获取下载列表
export function getExtDownloadList(current, size) {
  return request({
    method: 'get',
    url: serviceUrl.deviceService + '/ext/download/record/list',
    params: {current, size},
  })
}

//根据id删除下载信息
export function deleteDownloadInfoById(id) {
  return request({
    method: 'post',
    params: {id},
    url: serviceUrl.deviceService + '/ext/download/record/deleteById'
  })
}

//根据id删除所有下载信息
export function deleteDownloadAllInfo() {
  return request({
    method: 'post',
    params: {},
    url: serviceUrl.deviceService + '/ext/download/record/delete'
  })
}

//获取下载列表
export function getDatabasesList(current, size) {
  return request({
    method: 'get',
    url: serviceUrl.deviceService + '/ext/download/record/backUpDatabasesList',
    params: {current, size},
  })
}
